export interface IKoreanSchoolYearlyStatistic {
  id: number
  year: number
  schoolCount: number
  universityCount: number
  totalCount?: number
  createdDate?: string
  lastModifiedDate?: string
}

type ApiEnvelope<T = unknown> = {
  success: boolean
  message?: string
  data: T
}

const isApiEnvelope = (raw: unknown): raw is ApiEnvelope => {
  return !!raw && typeof raw === 'object' && 'success' in raw && 'data' in raw
}

export function normalizeKoreanSchoolYearlyStatistics(raw: unknown): IKoreanSchoolYearlyStatistic[] {
  if (Array.isArray(raw)) {
    return raw as IKoreanSchoolYearlyStatistic[]
  }

  if (isApiEnvelope(raw)) {
    const data = raw.data
    return Array.isArray(data) ? (data as IKoreanSchoolYearlyStatistic[]) : []
  }

  if (raw && typeof raw === 'object' && Array.isArray((raw as { data?: unknown[] }).data)) {
    return (raw as { data: IKoreanSchoolYearlyStatistic[] }).data
  }

  return []
}
